import { FC } from 'react';
import { DialogProps } from './dialog.type';

export const Dialog: FC<DialogProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`
        w-[90vw] max-w-[356px]  
        h-[80vh] max-h-[350px]  
        bg-[#F9F9FC]
        border-[0.6px] border-[#E7E8F6]
        shadow-[8px_8px_30px_#3C36CE1F]
        rounded-[15px]
        opacity-100
        z-[9999]
        p-4
        overflow-auto      
        ${className}
      `}
    >
      {children}
    </div>
  );
};
